<!-- eslint-disable vue/no-deprecated-slot-attribute -->
<template>
  <div slot="bvAverageRating" class="bazarvoice-container">
    <div class="bazar-voice-content">
      <div class="ratings">
        <sup>{{ bazarvoiceData.ReviewStatistics.AverageOverallRating.toFixed(1) }}</sup
        ><sub>/5</sub>
      </div>
      <div class="review">{{ bazarvoiceData.ReviewStatistics.TotalReviewCount }} {{ reviews }}</div>
      <star-rating
        :increment="0.01"
        :read-only="true"
        active-color="#337ab7"
        :border-width="3"
        border-color="transparent"
        :rounded-corners="true"
        :rating="bazarvoiceData.ReviewStatistics.AverageOverallRating"
        :star-size="20"
        :star-points="[23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46, 19, 31, 17]"
        :show-rating="false"
      >
      </star-rating>
    </div>
  </div>
</template>
<script>
import StarRating from 'vue-star-rating';

export default {
  name: 'bazar-voice-content',
  components: {
    StarRating,
  },
  props: {
    bazarvoiceData: {
      type: Object,
      required: true,
    },
    reviews: {
      type: String,
      required: true,
    },
  },
};
</script>
